import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, SecurityContext } from '@angular/core';
import { UiSvgIconModule } from '@big-direkt/ui/svg-icon';
import { IconComponent } from '@big-direkt/utils/icons';
import { Nl2brPipe, SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardBaseComponent } from '../../card-base.component';
import { CardLinkComponent } from '../card-link/card-link.component';
import { CardComponent } from '../card/card.component';
import { UiCardIconModel } from './card-icon.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-card-icon',
    templateUrl: './card-icon.component.html',
    imports: [CardComponent, CardLinkComponent, IconComponent, NgClass, Nl2brPipe, SanitizePipe, TranslocoDirective, UiSvgIconModule],
})
export class CardIconComponent extends CardBaseComponent {
    public readonly securityContext: SecurityContext = SecurityContext.HTML;

    public readonly data = input.required<UiCardIconModel>();
    public readonly iconLeft = input(false);
    public readonly hideLink = input(false);
    public readonly iconSize = input('w-12');
    public readonly iconCssClass = input('fill-primary');
    public readonly iconSvgCssClass = input('flex shrink-0 fill-primary dark:fill-white w-12');
}
